import React from 'react';
import { ExternalLink, IExternalLinkProps } from '../external-link';
import { ParagraphGroup } from '../paragraph-group';
import style from "./style.module.css";

export interface IChild {
    title: string
    body: string
    imgSrc?: string
    altText?: string
    link?: IExternalLinkProps;
}

export interface IImageTextTripletsProps {
    children: IChild[]
}

export function ImageTextTriplets(props: IImageTextTripletsProps) {
    return (
        <section className={style.imageTextTriplets}>
            {
                props.children.map((child: IChild) => {
                    return (
                        <section
                            key={child.title}
                            className={style.child}
                        >
                            {
                                child.imgSrc ?
                                    <img className={style.image} src={child.imgSrc || ""} alt={child.altText || ""} />
                                    : null
                            }
                            <ParagraphGroup
                                title={child.title}
                                body={[child.body]}
                                groupStyle={style.paragraphGroup}
                            />
                            {
                                child.link ?
                                    <ExternalLink
                                        cta={child.link.cta}
                                        url={child.link.url}
                                    />
                                    : null
                            }
                        </section>
                    );
                })
            }
        </section>
    )
}